import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getMobileNavLocationKey } from '../mobile-nav-location-key';

export const useMobileNav = () => {
  const location = useLocation();
  // query 기반 하위 메뉴 선택도 실제 화면 이동이므로 모바일 Drawer를 닫는다.
  const locationKey = getMobileNavLocationKey(location);
  const [open, setOpen] = useState(false);

  const handlePathnameChange = useCallback(() => {
    if (open) {
      setOpen(false);
    }
  }, [open]);

  useEffect(() => {
      handlePathnameChange();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [locationKey]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    handleOpen,
    handleClose,
    open
  };
};
